import { memo } from 'react';
import TableHeadCell from '../../../../core/components/table/TableHeadCell';
import TableRow from '../../../../core/components/table/TableRow';
import useCustomerPriceVisibility from '../../../../core/hooks/useCustomerPriceVisibility';
import useLoginState from '../../../../core/hooks/useLoginState';
import ProductHeaderCells from '../ProductHeaderCells';
import { TableHeadCellTitle } from './ProductCompatibilityTable';

const ProductVariantsTableHeadRow = ({
    hideImageColumn = false,
    siblingHeaders,
    variantHeaders,
    hasSiblings = false,
    hasVariants = false,
    showDiscountColumn,
    showBackordersColumn,
}: {
    hideImageColumn?: boolean;
    siblingHeaders?: string[];
    variantHeaders?: string[];
    hasSiblings?: boolean;
    hasVariants?: boolean;
    showDiscountColumn?: boolean;
    showBackordersColumn?: boolean;
}) => {
    const isLoggedIn = useLoginState();
    const [showCustomerPrice] = useCustomerPriceVisibility();

    return (
        <TableRow>
            {showBackordersColumn}
            {!hideImageColumn && (
                <TableHeadCell>
                    <TableHeadCellTitle messageId="image" />
                </TableHeadCell>
            )}
            <TableHeadCell>
                <TableHeadCellTitle messageId="article number" />
            </TableHeadCell>
            {hasSiblings &&
                siblingHeaders &&
                siblingHeaders.map(siblingHeader => (
                    <TableHeadCell key={`header_${siblingHeader}`}>
                        <TableHeadCellTitle>{siblingHeader}</TableHeadCellTitle>
                    </TableHeadCell>
                ))}
            {hasVariants &&
                variantHeaders &&
                variantHeaders.map(variantHeader => (
                    <TableHeadCell key={`header_${variantHeader}`}>
                        <TableHeadCellTitle>{variantHeader}</TableHeadCellTitle>
                    </TableHeadCell>
                ))}
            <ProductHeaderCells
                isLoggedIn={isLoggedIn}
                showCustomerPrice={showCustomerPrice}
                showDiscountColumn={showDiscountColumn}
                showBackordersColumn={showBackordersColumn}
            />
        </TableRow>
    );
};

export default memo(ProductVariantsTableHeadRow);
